<template>
    <span class="flex breadcrumbs" :class="{'flex-wrap': !noWrap}">
        <template v-for="(item, itemIndex) in items" :key="itemIndex">
            <nuxt-link v-if="item.to" :to="item.to" :exact="item.exact" :class="[sizeString ? 'text-' + sizeString : '', colorString ? 'text-' + colorString : '']" class="truncate" absolute-target="_blank" replace :style="{color: colorHex}">{{ item.text }}</nuxt-link>
            <span v-else :class="sizeString ? 'text-' + sizeString : ''" class="truncate">{{ item.text }}</span>
        </template>
        <slot/>
    </span>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";
    import Colorable from "../../mixins/Colorable";
    export default {
        name: "Breadcrumbs",

        mixins: [Sizeable, Colorable],

        props: {
            items: {
                type: Array,
                required: true
            },

            noWrap: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
.breadcrumbs > *:not(:last-child):after {
  content: "/";
  padding: 0 8px;
  color: #bebebe;
}
</style>